<template>
  <div class="mic-com goods-container">
    <div class="goods" :style="goodsStyle">
      <GoodsChunk
        v-for="(chunk, chunkIndex) in chunkList"
        @length-change="heightChange"
        chunk-type="goods"
        :key="chunk.key"
        :config="config"
        :data="chunk"
        :preview="preview"
      >
        <template v-slot="{ goods, index }">
          <GoodsCard
            :index="index"
            :key="goods.guid"
            :config="config"
            :data="goods"
          />
        </template>
        <template slot="append">
          <GoodsAllBtn :config="config" />
        </template>
      </GoodsChunk>
    </div>
    <div class="empty-image" v-if="!chunkList.length">
      <img :src="goods_empty" alt="" />
    </div>
  </div>
</template>

<script>
import GoodsCard from "./GoodsCard";
import GoodsAllBtn from "./GoodsAllBtn";
import Common from "../mixins/Common";
import * as shop from "@/api/shop";
import ChunkList from "../mixins/ChunkList";

export default {
  name: "goods",
  props: {},
  mixins: [Common, ChunkList],
  components: { GoodsCard, GoodsAllBtn },
  data() {
    return {
      chunkList: [],
      observerKeys: [
        "config.goods_from",
        "config.guids",
        "config.category_guid",
        "config.goods_number",
        "config.is_show_all",
        "config.category_total_goods_number"
      ],
      request: shop.getGoodsByIds
    };
  },
  created() {
    this.observerWhenPreview();
    this.createChunkList();
  },
  methods: {
    heightChange() {
      this.$nextTick(() => {
        this.$emit("height-change", this.$el.clientHeight);
      });
    }
  },
  computed: {
    // 数据来源是自动分页获取,按分类总量分组
    pageChunks() {
      const {
        goods_number,
        category_total_goods_number: total,
        is_show_all,
        category_guid
      } = this.config;
      if (!category_guid) return [];

      let count = Math.min(goods_number, total);
      if (is_show_all) {
        count = total;
      }
      return this.$utils
        .chunk(10)(count)
        .map((list, index) => ({
          key: category_guid + index,
          length: list.length,
          query: {
            pageIndex: index + 1,
            pageSize: Math.min(count, 10),
            categoryGuid: category_guid
          },
          request: shop.getGoodsByIds
        }));
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.goods-container {
  overflow: hidden;
}

.goods {
  overflow: hidden;
}
</style>
